import {UploadLocation} from '../../enum/upload-location';
import {ObjectUtil} from '../../util/object-util';

export class BinaryData {
  id: string = null;
  name: string = null;
  type: string = null;
  secret: string = null;
  sizeInBytes: number = null;
  hash: string = null;
  createDate: Date = null;
  uploadLocation: UploadLocation = null;

  constructor(object?: any) {
    ObjectUtil.assign(this, object, ['createDate']);
  }
}
